import React, { useState, useEffect } from "react";
import axios from "axios";
import "semantic-ui-css/semantic.min.css";
import { useAuth } from "../../../hook/userAuth";
import HeaderPage from "../../../components/HeaderPage/HeaderPage";
import ModalBasic from "../../../components/ModalBasic/ModalBasic";
import { AddEditMaterias } from "../../../components/GestionAcademica/TableMaterias/AddEditMaterias";
import { Navigate } from "react-router-dom";
import { BASE_API } from "../../../ruta-server/BaseApi";
import { Loader } from "semantic-ui-react";
import { TableMaterias } from "../../../components/GestionAcademica/TableMaterias/TableMaterias";
import Swal from "sweetalert2";

function Materias() {
  const { auth } = useAuth();
  if (!auth?.me?.es_personal_control_escolar) {
    return <Navigate to={"/"}></Navigate>;
  }
  return <LogicaMaterias />;
}

function LogicaMaterias() {
  const { auth } = useAuth();
  const [refetch, setRefetch] = useState(false);
  const [loading, setLoading] = useState(true);
  const [materias, setMaterias] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [titleModal, setTitleModal] = useState(null);
  const [contentModal, setContentModal] = useState(null);

  const openCloseModal = () => setShowModal((prev) => !prev);

  async function getMateriasApi() {
    try {
      setLoading(true);
      const response = await axios.get(`${BASE_API}/api/materia/`, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
      });

      const result = response.data;
      setLoading(false);
      setMaterias(result);

      return result;
    } catch (error) {
      setLoading(false);
      window.location.reload();
      window.location.href = "/Login";
    }
  }

  useEffect(() => {
    getMateriasApi();
    // eslint-disable-next-line
  }, [refetch]);

  const onRefetch = () => {
    setRefetch((prev) => !prev);
  };

  const ondelete = async (datosMateria) => {
    const confirmMessage = `¿Estás seguro de que deseas eliminar la materia con la clave: ${datosMateria.clave_materia}?
    <div style="color: red;">Nota: si la materia esta asignada a un curso en el sistema no será eliminada aunque esta acción sea 
    confirmada </div>`;

    const result = await Swal.fire({
      //title: '¿Estás seguro?',
      html: confirmMessage,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí",
      confirmButtonColor: "#2f6d02",
      cancelButtonText: "Cancelar",
      cancelButtonColor: "#920804",
      reverseButtons: true,
    });

    if (result.isConfirmed) {
      try {
        const response = await axios.delete(
          `${BASE_API}/api/materia/${datosMateria.id}/`,
          {
            headers: {
              Authorization: `Bearer ${auth.token}`,
            },
          }
        );
        const result = response.data;
        onRefetch();
        return result;
      } catch (error) {}
    }
  };

  const createMateria = () => {
    setTitleModal("Nueva materia");
    setContentModal(
      <AddEditMaterias onClose={openCloseModal} onRefetch={onRefetch} />
    );
    openCloseModal();
  };

  const updateMateria = (data) => {
    setTitleModal("Actualizar datos Materia");
    setContentModal(
      <AddEditMaterias
        onClose={openCloseModal}
        onRefetch={onRefetch}
        materia={data}
      />
    );
    openCloseModal();
  };

  return (
    <div>
      <h1 className="tituloin">Materias</h1>

      <HeaderPage
        btnTitulo="Registrar nueva materia"
        btnClick={createMateria}
      />
      {loading ? (
        <Loader active inline="centered">
          Cargando....
        </Loader>
      ) : (
        <TableMaterias
          materias={materias}
          deleteMateria={ondelete}
          updateMateria={updateMateria}
        />
      )}
      <ModalBasic
        show={showModal}
        title={titleModal}
        children={contentModal}
        close={openCloseModal}
      />
    </div>
  );
}

export default Materias;
